const STORY_CAVE_ENCOUNTER_MISSION_ID = "ambient-void-cave";
const STORY_CAVE_ENCOUNTER_SET_ID = "void-cave-roaming";
export const resolveStoryWorldEncounterLaunchContext = ({
  detail = null,
  activeRuntime = null,
  currentLaunchTarget = null,
} = {}) => ({
  missionId: String(
    detail?.missionId || activeRuntime?.missionId || currentLaunchTarget?.missionId || "",
  ),
  encounterMode: String(
    detail?.encounterMode ||
      activeRuntime?.encounterMode ||
      currentLaunchTarget?.encounterMode ||
      "",
  ),
  encounterSetId: String(
    detail?.encounterSetId ||
      activeRuntime?.encounterSetId ||
      currentLaunchTarget?.encounterSetId ||
      "",
  ),
  world: detail?.world || activeRuntime?.world || currentLaunchTarget?.world || null,
});

export const STORY_WORLD_ENCOUNTER_RELEASE_EVENT =
  "story-world-encounter-release";

export const resolveStoryWorldEncounterLaunchDecision = ({
  detail = null,
  activeRuntime = null,
  currentLaunchTarget = null,
  defeatedEncounterIds = [],
  expectedEncounterMode = "roamingCreatureClear",
  expectedSceneKey = "",
} = {}) => {
  const context = resolveStoryWorldEncounterLaunchContext({
    detail,
    activeRuntime,
    currentLaunchTarget,
  });
  const encounterId = String(detail?.encounterId || "");
  const sceneKey = String(detail?.sceneKey || "");
  const isAmbientCaveEncounter =
    context.missionId === STORY_CAVE_ENCOUNTER_MISSION_ID &&
    context.encounterSetId === STORY_CAVE_ENCOUNTER_SET_ID;
  const resolvedExpectedSceneKey = String(
    expectedSceneKey ||
      (isAmbientCaveEncounter ? sceneKey : activeRuntime?.sceneKey) ||
      "WhisperingForestScene",
  );
  const activeRuntimeMissionId = String(activeRuntime?.missionId || "");
  const defeatedEncounterIdSet = new Set(
    (Array.isArray(defeatedEncounterIds) ? defeatedEncounterIds : []).map(String),
  );

  let reason = "accepted";
  if (!encounterId) {
    reason = "missing-encounter";
  } else if (!context.missionId) {
    reason = "missing-mission";
  } else if (context.encounterMode !== expectedEncounterMode) {
    reason = "invalid-encounter-mode";
  } else if (sceneKey && sceneKey !== resolvedExpectedSceneKey) {
    reason = "invalid-scene";
  } else if (
    !isAmbientCaveEncounter &&
    activeRuntimeMissionId &&
    context.missionId !== activeRuntimeMissionId
  ) {
    reason = "mission-mismatch";
  } else if (defeatedEncounterIdSet.has(encounterId)) {
    reason = "already-defeated";
  }

  return {
    accepted: reason === "accepted",
    reason,
    encounterId,
    sceneKey,
    context,
  };
};

export const releaseStoryWorldEncounterLaunch = ({
  globalScope = typeof window !== "undefined" ? window : null,
  encounterId = "",
} = {}) => {
  if (!globalScope) return false;

  const normalizedEncounterId = String(encounterId || "");
  const pendingEncounterId = String(
    globalScope.__pendingStoryWorldEncounter?.encounterId || "",
  );
  if (
    normalizedEncounterId &&
    pendingEncounterId &&
    normalizedEncounterId !== pendingEncounterId
  ) {
    return false;
  }

  delete globalScope.__storyWorldEncounterPaused;
  delete globalScope.__pendingStoryWorldEncounter;
  return true;
};
